import $ from "jquery"

$(function () {

	const siteKey = $('meta[name=rcsitekey]').attr('content');
	const $forms = $('form');

	const submitAjax = function ($form) {
		const ajaxUrl = $form.data('ajaxurl');
		const csrfToken = $('meta[name="csrf-token"]').attr('content');
		const csrfField = $('meta[name="csrf-param"]').attr('content');
		const $button = $form.find('button[type=submit]');

		//Add csrf to form
		$form.find('input[name=' + csrfField + ']').remove();
		$form.append('<input name="' + csrfField + '" type="hidden" value="' + csrfToken + '"/>');

		//Send form with ajax
		$.ajax({
			url: ajaxUrl,
			data: $form.serialize(),
			type: 'POST',
			beforeSend: function () {
				//Turn on loading state of submit button
				$button.addClass('loading');
			},
		}).done(function (data) {
			//Successful response, remove validaton states, and reset the form
			$form.find('div.alert').remove();
			$form.append('<div class="alert alert-success">' + data.message + '</div>');
			$form.trigger('reset');
			$form.removeClass('was-validated');
			$form.find('*').removeClass('is-invalid').removeClass('is-valid');
		}).fail(function (jqXHR, textStatus) {
			//Error responses, remove previous validation states
			$form.find('div.alert').remove();
			$form.find('*').removeClass('is-invalid').addClass('is-valid');
			$form.find('.invalid-feedback').remove();

			const alerts = [];
			if (jqXHR.status === 422) {
				$form.removeClass('was-validated');
				//Invalid, show validation errors
				const errors = jqXHR.responseJSON;
				if (errors instanceof Object) {
					for (let field in errors) {
						const fieldErrors = errors[field];
						const $field = $form.find('*[name="' + field + '"]');

						if ($field.length && fieldErrors instanceof Array) {
							if ($field.attr('type') === 'hidden') {
								//Field is hidden, show error as a global alert (like captcha)
								alerts.push({ type: 'danger', message: fieldErrors.join('<br/>') });
							} else {
								//Field is visible, add invalid feedback
								$field.addClass('is-invalid');
								$field.siblings('.invalid-feedback').remove();
								$field.after('<div class="invalid-feedback">' + fieldErrors.join('<br/>') + '</div>');
							}
						}
					}
				} else {
					//Add global alert, because a validation field isn't found
					alerts.push({ type: 'danger', message: 'Ismeretlen hiba történt a küldés során' });
				}
			}
			if (jqXHR.status === 500) {
				//Server error, add an alert with the received message, or add a general one
				if (jqXHR.responseJSON instanceof Object && typeof jqXHR.responseJSON.message !== 'undefined') {
					alerts.push({ type: 'danger', message: jqXHR.responseJSON.message });
				} else {
					alerts.push({ type: 'danger', message: 'Ismeretlen hiba történt a küldés során' });
				}
			}

			//Add general alerts
			alerts.forEach(function (alert) {
				$form.append('<div class="alert alert-' + alert.type + '">' + alert.message + '</div>');
			});
		}).always(function (jqXHR) {
			$button.removeClass('loading');
		});
	}

	$forms.each(function () {
		const $form = $(this);
		if ($form.attr('id') === 'mc-embedded-subscribe-form') {
			//Mailchimp form, skip
			return;
		}
		//Add captcha response field
		$form.append('<input name="recaptcha_response" type="hidden"/>');

		$form.on('submit', function (e) {
			//Validate with client side validation
			if ($form.hasClass('needs-validation')) {
				$form.addClass('was-validated');
				if (!$form[0].checkValidity()) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
			}

			//Validate captcha, and submit the form
			e.preventDefault();
			grecaptcha.ready(function () {
				grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
					$form.find('input[name=recaptcha_response]').val(token);
					if ($form.data('ajaxurl')) {
						submitAjax($form);
					} else {
						$form[0].submit();
					}
				});
			});

		});
	});

});
